import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import styles from "../ImageQuickLinks/ImageQuickLinks.module.scss";
import Srcset from "@/components/common/Srcset";
import { selectSliderElementsGen } from "@/helpers/generalHelper";

const getResizedImageURL = (imageURL,width) => {
    if(!imageURL) return "";
    return `${imageURL}&width=${width}`;
}

function NextArrow(props) {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick} tabIndex={0}>
        <Srcset
            requirePath={true}
            svgFile={true}
            src={"images/Icons/Arrow/Right/Large_dark.svg"}
            alt="Arrow Button"
            height="12"
            width="12"
        />
        </div>
    );
}
  
function PrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick} tabIndex={0}>
        <Srcset
            requirePath={true}
            svgFile={true}
            src={"images/Icons/Arrow/Right/Large_dark.svg"}
            alt="Arrow Button"
            height="12"
            width="12"
        />
        </div>
    );
}

const ImageQuickLinksCarousel = (props) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 600px)");

  // Filter quick links to only include products that are available for the current device
  const isAvailable = (e) => {
  // Prefer device-specific product, fallback to desktop if not present
  const productData =
    (isMobile && e?.mobileProduct?.data) ? e.mobileProduct.data :
    (isTablet && e?.tabletProduct?.data) ? e.tabletProduct.data :
    e?.desktopProduct?.data;

    return productData?.availableForSale;
  };

  const filteredQuickLinks = props?.imageQuickLinks?.filter(isAvailable);

  let settings = {
    accessibility:true,
    speed: 500,
    slidesToShow: Math.min(filteredQuickLinks?.length,7),
    slidesToScroll: 7, 
    infinite: filteredQuickLinks?.length > 7,
    arrows: true,
    autoplay: false,
    lazyLoad: true,
    draggable: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
    {
        breakpoint: 600,
        settings: {
        slidesToShow: 3.8,
        slidesToScroll: 3,
        arrows: false,
        autoplay: false,
        draggable: true,
        },
    },
    {
        breakpoint: 1025,
        settings: {
        slidesToShow: 7,
        slidesToScroll: 7,
        arrows: false,
        autoplay: false,
        draggable: true,
        },
    }]
  };

  const sliderRef= useRef(null); 
  const [tabPressed, setTabPressed] = useState(false);

  useEffect(()=>{
    if(!isDesktop){
      return;
    }
    // to handle tabindexing
    const handleKeyDown = (event) =>{
      if(event.key === "Tab" && !tabPressed){
        setTabPressed(true);
        selectSliderElementsGen(sliderRef);
      } 
    };
    const handleKeyUp = (event) =>{
      if(event.key === "Tab" ){
        setTabPressed(false);
      }
    };

    window.addEventListener("keydown",handleKeyDown);
    window.addEventListener("keyup",handleKeyUp);

    return ()=>{
      window.removeEventListener("keydown",handleKeyDown);
      window.removeEventListener("keyup",handleKeyUp);
    }
  },[sliderRef,tabPressed,isDesktop]);

  const renderImage = (image) => {
    const resizedWidth = isDesktop? 620 : isTablet? 480 : 360;
    const resizedImageUrl = getResizedImageURL(image, resizedWidth);
    
    return (resizedImageUrl);
  }

const slides = filteredQuickLinks?.map((e, index) => {
  let displayText = isMobile && e?.mobileDisplayText ? e?.mobileDisplayText
    : isTablet && e?.tabletDisplayText ? e?.tabletDisplayText
    : e?.desktopDisplayText;
  let url = isMobile && e?.mobileUrl ? e?.mobileUrl
    : isTablet && e?.tabletUrl ? e?.tabletUrl
    : e?.desktopUrl;
  let image = isMobile && e?.mobileProduct?.data?.images?.[0]?.src ? renderImage(e?.mobileProduct?.data?.images?.[0]?.src)
    : isTablet && e?.tabletProduct?.data?.images?.[0]?.src ? renderImage(e?.tabletProduct?.data?.images?.[0]?.src)
    : renderImage(e?.desktopProduct?.data?.images?.[0]?.src);
  return (
    image && <a tabIndex={0} key={index} href={url} className={`${styles.quickLink}`}>
      {image ? (
        <>
          <div className={`${styles.quickLinkImage}`}>
            <img src={image + "&width=240"} alt={displayText} className={`ga-plp-quick-links ${styles.shopifyImage}`} />
          </div>
          <span className={`x-small-md x-small-sm x-small-xs ga-plp-quick-links ${styles.categorySpan}`}>{displayText}</span>
        </>
      ) : (
        <button type="button" className={`ga-plp-quick-links ${styles.quickLinkButton}`} aria-label={displayText}>{displayText}</button>
      )}
    </a>
  );
});

  return (
    filteredQuickLinks.length>4 ? <div className={`${styles.imageQuickLinks}`} >
      <Slider ref={sliderRef} aria-live="polite" role="region" lazyLoad="ondemand" {...settings}>
        {slides}
      </Slider>
    </div> :<></>
  );
};

export default ImageQuickLinksCarousel;